module.exports = __webpack_public_path__ + "static/media/7.cfac1fc1.jpg";